import { useMutation, useQueryClient } from 'react-query';

import { addMultiTrapToObject as add } from 'api/traps/Trap/addMultiTrapToObject';
import { TrapTableType } from 'components/TrapsTables/trapTables';

const useAddTrapToObj = (trapTableType: TrapTableType) => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: addTrapToObject,
    isLoading,
  } = useMutation(add, {
    onSuccess: () => {
      queryClient.refetchQueries(trapTableType);
    },
  });

  return {
    isSuccess,
    addTrapToObject,
    isLoading,
  };
};

export default useAddTrapToObj;
